'use client';

import { QueryClientProvider } from '@tanstack/react-query';
import { RouteGuard } from '@/components/ui-components';
import { AuthProvider } from '@/context/AuthContext';
import { OrganizationProvider } from '@/context/OrganizationContext';
import { ThemeProvider } from '@/context/ThemeContext';
import { ToastProvider } from '@/context/ToastContext';
import { TimezoneProvider } from '@/context/TimezoneContext';
import { queryClient } from '@/config/queryClient';
import React from 'react';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ToastProvider>
          <TimezoneProvider>
            <AuthProvider>
              <OrganizationProvider>
                <RouteGuard>
                  {children}
                </RouteGuard>
              </OrganizationProvider>
            </AuthProvider>
          </TimezoneProvider>
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

